import { ComponentElem } from "@components/interfaces";
import Popups from "@components/popups/Popups";
import PatternSamples from "@root/ts/PatternSamples";
import EZAlert from "../popups/EZAlert";
import FormTools from "@root/ts/FormTools";
import SearchbarPrototype from "../shared/SearchbarPrototype";
import { generateSearchQuery } from "../search/SearchManager";
import ApiProxy from "../../ts/ApiProxy";

export default class IndexSearchbar extends SearchbarPrototype
{
  constructor(elem: ComponentElem)
  {
    super(elem);    

    this.$root.find(".cover-block").on("click", (event:Event)=>
    {
      event.preventDefault();
      Popups.to("search-popup");
    });

    this.$root.find(".btn-search").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();

      let formData = this.getFormData();      
      
      if(formData)
      {
        // console.log(formData);

        let obj = 
        {
          "keyword": formData["keyword"],
          "sort": formData["sort"],
          "start-date": formData["start_date"],
          "end-date": formData["end_date"],
        };

        let query = generateSearchQuery(obj);
        window.location.href = ApiProxy.getCommonPageData().search_page_path + "?" + query;
        
        // FormTools.sendForm("common/search", formData, undefined, {schema: schema}).then((result)=>
        // {
        //   FormTools.handleNextUrl(result);
        // });
      }
      
    });
  }

  getFormData()
  {
    let keyword = this._keywordInputElem.value;

    if(!PatternSamples.simple.test(keyword))
    {
      EZAlert.alert("請輸入城市、景點或活動名稱");
      return false;
    }
    else
    {
      this.input.keyword = keyword;
      return this.input;
    }
  }
}